import Channel from "data/websocket/channel"
import * as eventType from "data/socket"
import versionService from "data/version"

// GlobalChannel manages app wide messages that all users receive
export default class GlobalChannel extends Channel {

  connectGlobal() {
    this.join('global');

    this.onEvent(event => {
      switch(event.eventType) {
        case eventType.APPVERSION:
          // emit version change notification after 30 minutes to allow deployment to finish
          setTimeout(() => versionService.newVersion(event.msg), 1800000);
          break;

        default:
          console.warn('GlobalChannel got unknown eventType on:', event)
      }
    });
  }
}